class DetalhesTributacaoPisCofins {
    $onInit() {
        const {pisCofins, resultado, empresa} = this.resolve
        
        this.pisCofins = pisCofins
        this.resultado = resultado
        this.empresa = empresa
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('detalhesTributacaoPisCofins', {
        controller: [DetalhesTributacaoPisCofins],
        bindings: {
            resolve: '=',
            close: '&'
        },
        template: `
        <modal modal-title="{{$ctrl.pisCofins.descricao | limitToDots:80}}" close="$ctrl.close">
            <modal-body>
                <div class="clearfix" style="border: 1px #e5e5e5 solid; border-radius: 3px;">
                    <table ng-if="$ctrl.pisCofins.resultado.completo" class="table table-hover">
                        <thead>                        
                            <tr>
                                <th>Descrição</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{$ctrl.resultado.descricaoProduto}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Operação</th>
                                <th>Código SPED</th>
                                <th>Tabela SPED</th>
                                <th>Legislação de Referência</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{$ctrl.resultado.situacao}}</td>
                                <td>{{$ctrl.resultado.codigo || '--'}}</td>
                                <td>{{$ctrl.resultado.codigoTabela || '--'}}</td>
                                <td ng-if="$ctrl.resultado.legislacaoLink">
                                    <a target="_blank" ng-href="{{$ctrl.resultado.legislacaoLink}}">
                                        {{$ctrl.resultado.legislacaoRef}}
                                    </a>
                                </td>
                                <td ng-if="!$ctrl.resultado.legislacaoLink">
                                    {{$ctrl.resultado.legislacaoRef}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="no-break">Alíquota PIS</th>
                                <th class="no-break">CST Entrada PIS</th>
                                <th class="no-break">CST Saída PIS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td ng-if="$ctrl.resultado.pis != undefined">
                                    {{$ctrl.resultado.pis}}%
                                </td>
                                <td ng-if="$ctrl.resultado.pis == undefined">
                                    Isento
                                </td>
                                <td>
                                    {{$ctrl.resultado.cst_pis_entrada}} - {{$ctrl.resultado.cst_pis_entrada_descricao}}
                                </td>
                                <td>{{$ctrl.resultado.cst_pis_saida}} - {{$ctrl.resultado.cst_pis_saida_descricao}}
                                </td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th class="no-break">Alíquota COFINS</th>
                                <th class="no-break">CST Entrada COFINS</th>
                                <th class="no-break">CST Saída COFINS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td ng-if="$ctrl.resultado.cofins != undefined">
                                    {{$ctrl.resultado.cofins}}%
                                </td>
                                <td ng-if="$ctrl.resultado.cofins == undefined">Isento</td>
                                <td>
                                    {{$ctrl.resultado.cst_cofins_entrada}} - {{$ctrl.resultado.cst_cofins_entrada_descricao}}
                                </td>
                                <td>
                                    {{$ctrl.resultado.cst_cofins_saida}} - {{$ctrl.resultado.cst_cofins_saida_descricao}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
